module.exports = __webpack_public_path__ + "static/media/close-white.759123d9.svg";